module.exports = __webpack_public_path__ + "static/media/pm-delete-icon.30f051c2.svg";